module.exports = __webpack_public_path__ + "static/media/map_layer.d7647efc.png";